import onHoldComponent from "./on_hold.component";

let onHoldModule = angular.module('onHold', [])
    .component('onHold', onHoldComponent)
    .name;

export default onHoldModule;



// WEBPACK FOOTER //
// ./client/app/components/reporting/components/on_hold/index.js